import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { assertNever } from 'src_common/common/assertNever';
import { InfoPopup } from 'src/domains/players/webview/components/SignUp/signupPrimary/signupPopups/InfoPopup';
import { AgreeOrCancelPopup } from 'src/domains/players/webview/components/SignUp/signupPrimary/signupPopups/AgreeOrCancelPopup';
import { useCommon } from 'src/domains/common/Common';
import { AppPlayersState } from 'src/domains/players/state/AppPlayers.state';

export const SignupPopupContainer = observer('SignupPopupContainer', (): JSX.Element | null => {
    const common = useCommon();
    const appPlayersState = AppPlayersState.get(common);
    const { signupPopupState } = appPlayersState;

    if (signupPopupState.popups === null) {
        return null;
    }

    const popup = signupPopupState.popups;
    if (popup.type === 'infoPopup') {
        return <InfoPopup popup={popup} />;
    }
    if (popup.type === 'agreeOrCancel') {
        return <AgreeOrCancelPopup popup={popup} />;
    }
    return assertNever('', popup);
});
